
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_categorias,
} from '../../actions/auth.actions';


import './main.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pmain = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_categorias,
	set_lofty_global_categorias_app,

}) => {





	function function_redirigircontactanos_694618e38e5aed52dc8d5526() {
		history.push("https://wa.me/50487475208");
	}


  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6942dbbe599f24ea479be75e" >

      <div id="iy5xkq" className="">
      
      <div id="icuq" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="aboutus"
        type=""
      >
        <>Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/services"
        type=""
      >
        <>Servicios</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/blog"
        type=""
      >
        <>Blog</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactus"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="ibznw" className="">
      
      <img
        className=""
        id="ipd1e"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpgsvh2.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ig5a" className="">
      
        <a
          target=""
          className=""
          id="iope"
          href={`/`}
        >
          
    <div id="iye9" className="">
    <>Ini</>
      <a
        target=""
        className=""
        id="id3bxh"
        href=""
        type=""
      >
        
      </a>
      <>cio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i848v"
          href={`/aboutus`}
        >
          
    <div id="i8s6k" className="">
    <>Nosotros</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="irmrk"
          href={`/services`}
        >
          
    <div id="ib721" className="">
    <>Servicios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwshj"
          href="/blog"
        >
          
    <div id="i5dsy" className="">
    <>Blog</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipsxb"
          href="/contactus"
        >
          
    <div id="ii21f" className="">
    <>Contacto</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="ib6b7" className="">
      
      <div id="iv94u" className="">
      
      <img
        className=""
        id="iwpbk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpgxdbe.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="i7dif"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgph1jxm.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ixytr"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpgza38.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ik2tyw" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/soluciones"
        type=""
      >
        <>Soluciones</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobregrowth"
        type=""
      >
        <>Sobre Growth</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/casosdeexito"
        type=""
      >
        <>Casos de Éxito</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/blog"
        type=""
      >
        <>Blog</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactanos"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="ia1n3y" className="">
      
        <a
          target=""
          className=""
          id="iusws2"
          href="/"
        >
          
      <img
        className=""
        id="ihujtl"
        src="https://assetsprojects.s3.amazonaws.com/405gznimp7daiji.jpg"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="iz4y4l" className="">
      
        <a
          target=""
          className=""
          id="i8celf"
          href="/soluciones"
        >
          
    <div id="ia1pya" className="">
    <>SOLUCIONES</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="id8oeu"
          href="/sobregrowth"
        >
          
    <div id="iybbsy" className="">
    <>NOSOTROS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i2iwa9"
          href="/casosdeexito"
        >
          
    <div id="isd869" className="">
    <>CASOS DE ÉXITO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ivkull"
          href="/blog"
        >
          
    <div id="ioy42x" className="">
    <>BLOG</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ij30on"
          href="/contactanos"
        >
          
    <div id="i8hbkb" className="">
    <>CONTACTO</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="izd1z6" className="">
      
      <div id="iccnds" className="">
      
      <img
        className=""
        id="ia718v"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpgxdbe.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="i5xjy6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgph1jxm.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="iprlu7"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpgza38.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="iv0wbr"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="ivhrha" className="">
      
      <div id="i194y1" className="">
      
      <img
        className=""
        id="i5lm34"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      
        <a
          target=""
          className=""
          id="id0ed9"
          href="#"
        >
          
      <img
        className=""
        id="iwlrjo"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpiasyr.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="iqbili"
          href="#"
        >
          
      <img
        className=""
        id="ipl1kk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpieb1l.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="iu8ocb"
          href="#"
        >
          
      <img
        className=""
        id="iubnel"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpieyc5.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="izp63u"
          href="#"
        >
          
      <img
        className=""
        id="ifyua4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpifmoh.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
      <img
        className=""
        id="i5wn3u"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ikn3q1" className="">
      
      <div id="iky9qz" className="">
      
      <div className="" id="i7aehz">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iou3bn">
        <>Digital Media</>
      </span>
      
      </div>
      <>
        </>
      </div>
      
      <div id="ik9cd4" className="">
      
      <div className="" id="iqae4g">
        <>MÁS CLIENTES,</>
      <br className="" id="" />
      <>MENOS COMPLICACIONES</>
      </div>
      <>
        </>
      </div>
      
      <div id="ic08ba" className="">
      
      <div className="" id="i9oq4l">
        <>Aceleramos resultados con estrategias claras, ejecución</>
      <br className="" id="" />
      <> creativa y métricas que importan.</>
      </div>
      <>
        </>
      </div>
      
      <div id="ivt6ln" className="">
      
      <button
        type=""
        name=""
        id="ifkp0v"
        className=""
        
      >
      
      <div id="if7r9u" className="">
      <>Habla con un especialista</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ibhsqe" className="">
      
      <div id="i89326" className="">
      
      <div id="ifxdgp" className="">
      
      <div className="" id="iv5qx8">
        <>Organizar redes sociales</>
      </div>
      <>
        </>
      </div>
      
      <div id="ipv70i" className="">
      
      <div className="" id="iiin3n">
        <>UI & UX Design</>
      </div>
      <>
        </>
      </div>
      
      <div id="iy98th" className="">
      
      <div className="" id="imf9re">
        <>Optimización de motores de búsqueda</>
      </div>
      <>
        </>
      </div>
      
      <div id="ict4pe" className="">
      
      <div className="" id="ilpw7b">
        <>Google Ads Optimización</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ixyh4c" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="ibjzhj"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="ibplva" className="">
      
      <div id="igfb0j" className="">
      
      <img
        className=""
        id="ijy08x"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      
        <a
          target=""
          className=""
          id="iso8ji"
          href="#"
        >
          <>
        </>
        </a>
        
      <img
        className=""
        id="iibpvc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="im89d5" className="">
      
      <div id="i9jq9s" className="">
      
      <div className="" id="ifr6hk">
        
      <span className="a_GcMg font-feature-liga-off font-feature-clig-off font-feature-calt-off text-decoration-none text-strikethrough-none " id="iflyhm">
        <>"Transformamos negocios en marcas digitales estructuradas, escalables y listas para expandir sus ventas dentro y fuera del país."</>
      </span>
      
      </div>
      <>
        </>
      </div>
      
      <div id="iqg4jj" className="">
      
      <button
        type=""
        name=""
        id="i8sqsl"
        className=""
        onClick={async () => {
		function_redirigircontactanos_694618e38e5aed52dc8d5526();
}}

      >
      
      <div id="i067bs" className="">
      <>AGENDAR CITA</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i41d63" className="">
      
      <div id="iof4d6" className="">
      
      <div id="ix3p4m" className="">
      
      <div className="" id="iyc1yh">
        <>Organizar redes sociales</>
      </div>
      <>
        </>
      </div>
      
      <div id="igv15k" className="">
      
      <div className="" id="imm5zi">
        <>UI & UX Design</>
      </div>
      <>
        </>
      </div>
      
      <div id="i01co5" className="">
      
      <div className="" id="ipv8pu">
        <>Optimización de motores de búsqueda</>
      </div>
      <>
        </>
      </div>
      
      <div id="ivrbb5" className="">
      
      <div className="" id="iwtr7e">
        <>Google Ads Optimización</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ia40nf" className="">
      <>
        </>
      </div>
      
      <div id="iklgbl" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i7c4v6" className="">
      
      <div id="ilu3si" className="">
      
      <div
        id="id2loe"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="i84bp5" className="">
      
      <div className="" id="irz86c">
        <>Confían en nosotros</>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="i3hafq"
        className=""
        data-aos="fade-right"
        data-aos-duration="undefined"
      >
      
      <div id="i6x6ms" className="">
      
      <div id="iyzx8t" className="">
      
      <img
        className=""
        id="ifa1qz"
        src="https://assetsprojects.s3.amazonaws.com/405gznimp7e2d4w.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="izmx93" className="">
      
      <img
        className=""
        id="iskf6h"
        src="https://assetsprojects.s3.amazonaws.com/405gznimp7e2son.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ipnsb7" className="">
      
      <img
        className=""
        id="ia5u4k"
        src="https://assetsprojects.s3.amazonaws.com/405gznimp7e31dq.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iclype" className="">
      
      <img
        className=""
        id="iyx223"
        src="https://assetsprojects.s3.amazonaws.com/405gznimp7e2dh7.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i2o4n5" className="">
      
      <img
        className=""
        id="ij8beh"
        src="https://assetsprojects.s3.amazonaws.com/405gznimp7e2deg.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div
        id="i51zg8"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="iy4f5g" className="">
      
      <div className="" id="itsxx5">
        <>¿Qué soluciones ofrecemos?</>
      </div>
      
      <div className="" id="iu08g9">
        <>Una suite de servicios para impulsar tu crecimiento de forma medible.</>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="iczwg5" className="">
      
      <div id="idykzx" className="">
      
      <div className="" id="ihvicn">
        
      <span className="" id="i7wmqj">
        <>GROWTH STRATEGY</>
      </span>
      
      </div>
      
      <div className="" id="i0u3kk">
        
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ip7b2r" className="">
      
      <div id="iqs6r6" className="">
      
      <div
        id="in3kzc"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="ijnapq" className="">
      
      <div id="ixe5uv" className="">
      
      <div id="ij3ddn" className="">
      
      <img
        className=""
        id="ii3pjx"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpwwe74.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="ij5s3c">
        <>Estrategia & Marca</>
      </div>
      <>
        </>
      </div>
      
      <div id="iazkgd" className="">
      
      <div id="iicliq" className="">
      
      <img
        className=""
        id="ibuo3b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh0yguwn.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="iffa8e">
        <>Contenido & SEO</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="itu3ib"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="ic6xlc" className="">
      
      <div id="it2ssj" className="">
      
      <div id="i31f1l" className="">
      
      <img
        className=""
        id="ii1buf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh0yguwn.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="iaawt9">
        <>Performance</>
      <br className="" id="" />
      <> & Paid Media</>
      </div>
      <>
        </>
      </div>
      
      <div id="ixhbo3" className="">
      
      <div id="i9k73i" className="">
      
      <img
        className=""
        id="i0ieu3"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpwwe74.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="i6w7zc">
        <>Email & </>
      <br className="" id="" />
      <>Automatización</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="ixap8e"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="ixm0sj" className="">
      
      <div id="io4o3w" className="">
      
      <div id="i8f26d" className="">
      
      <img
        className=""
        id="ifxju7"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpwwe74.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="ic269k">
        <>Email & </>
      <br className="" id="" />
      <>Automatización</>
      </div>
      <>
        </>
      </div>
      
      <div id="i94n9q" className="">
      
      <div id="iulzrp" className="">
      
      <img
        className=""
        id="ibm1mi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh0yguwn.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="i8mqcm">
        <>I Want Leads</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iln4il" className="">
      
      <div id="ixqyil" className="">
      
      <div
        id="i20tf8"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="ikx6oi" className="">
      
      <div id="iwr9ug" className="">
      
      <div className="" id="ixmbiy">
        <>//</>
      </div>
      
      <div className="" id="icn6wg">
        <>GROWTH</>
      <br className="" id="" />
      <> STRATEGY</>
      </div>
      <>
        </>
      </div>
      
      <div id="iz8eci" className="">
      
      <div className="" id="iiwgcf">
        <>//</>
      </div>
      
      <div className="" id="imnclv">
        <>CRO &#40;Conversion Rate Optimization)</>
      </div>
      <>
        </>
      </div>
      
      <div id="i5btbf" className="">
      
      <div className="" id="ivc65f">
        <>//</>
      </div>
      
      <div className="" id="i3mohx">
        <>RETENTION & FLOW</>
      </div>
      <>
        </>
      </div>
      
      <div id="iq9jaj" className="">
      
      <div className="" id="iv2b3y">
        <>//</>
      </div>
      
      <div className="" id="i7dgnz">
        <>ESTRATEGIA COMERCIAL</>
      </div>
      <>
        </>
      </div>
      
      <div id="i7jicz" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i9e7ag" className="">
      
      <div id="i1kf6z" className="">
      
      <div className="" id="ijnybj">
        <>//</>
      </div>
      
      <div className="" id="i6mijg">
        <>MARCA PERSONAL</>
      </div>
      <>
        </>
      </div>
      
      <div id="i6vkwf" className="">
      
      <div className="" id="inp6gk">
        <>//</>
      </div>
      
      <div className="" id="i1jej3">
        <>PAID MEDIA</>
      </div>
      <>
        </>
      </div>
      
      <div id="ifthmk" className="">
      
      <div className="" id="ilrv5s">
        <>//</>
      </div>
      
      <div className="" id="it2w6u">
        <>MARKETING AUTOMATION</>
      </div>
      <>
        </>
      </div>
      
      <div id="il63og" className="">
      
      <div className="" id="ikgbjg">
        <>//</>
      </div>
      
      <div className="" id="ioac9q">
        <>DISEÑO Y PRODUCCIÓN</>
      </div>
      <>
        </>
      </div>
      
      <div id="iguffd" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i7yuyy" className="">
      
      <div id="i7449n" className="">
      
      <div className="" id="ie6tjx">
        <>//</>
      </div>
      
      <div className="" id="i4eo4i">
        <>PRICING INTELLIGENCE</>
      </div>
      <>
        </>
      </div>
      
      <div id="ixnbxh" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="i8ql1g"
        className=""
        data-aos="fade-up"
        data-aos-duration="10"
      >
      
      <div id="isd1jh" className="">
      
      <div id="ikeymi" className="">
      
      <div className="" id="iywsj7">
        <>//</>
      </div>
      
      <div className="" id="i411xl">
        <>GROWTH</>
      <br className="" id="" />
      <> STRATEGY</>
      </div>
      
      <img
        className=""
        id="iurxnu"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjdjuriv.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="izr554" className="">
      
      <div className="" id="islmii">
        <>//</>
      </div>
      
      <div className="" id="iqqotj">
        <>CRO &#40;Conversion Rate Optimization)</>
      </div>
      
      <img
        className=""
        id="iql0f6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjdjz0xi.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="idhutg" className="">
      
      <div className="" id="its7sh">
        <>//</>
      </div>
      
      <div className="" id="iakdo6">
        <>RETENTION & FLOW</>
      </div>
      
      <img
        className=""
        id="ion1pg"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjdk2cb6.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ipytty" className="">
      
      <div className="" id="iiatcn">
        <>//</>
      </div>
      
      <div className="" id="ieg06k">
        <>ESTRATEGIA COMERCIAL</>
      </div>
      
      <img
        className=""
        id="izz1yl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjdk6c2r.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i52n84" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ibna8x" className="">
      
      <div id="i8juwg" className="">
      
      <div className="" id="i2j49z">
        <>//</>
      </div>
      
      <div className="" id="iaghc1">
        <>MARCA PERSONAL</>
      </div>
      
      <img
        className=""
        id="ixldgo"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjdkjlng.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i1hr0v" className="">
      
      <div className="" id="ipxp83">
        <>//</>
      </div>
      
      <div className="" id="iiix9d">
        <>PAID MEDIA</>
      </div>
      
      <img
        className=""
        id="idgbvh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjdkoxch.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i4d3qi" className="">
      
      <div className="" id="isa80n">
        <>//</>
      </div>
      
      <div className="" id="ixy9dh">
        <>MARKETING AUTOMATION</>
      </div>
      
      <img
        className=""
        id="inhmd9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjdkwhzn.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i2izak" className="">
      
      <div className="" id="itv4ir">
        <>//</>
      </div>
      
      <div className="" id="i3df2i">
        <>DISEÑO Y PRODUCCIÓN</>
      </div>
      
      <img
        className=""
        id="i3jnwk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjdl8zno.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i3kt61" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="it2pfk" className="">
      
      <div id="isl6dt" className="">
      
      <div className="" id="iddetf">
        <>//</>
      </div>
      
      <div className="" id="ib71qr">
        <>PRICING INTELLIGENCE</>
      </div>
      
      <img
        className=""
        id="i2miu9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjdlike4.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="igsfrl" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="ia1vjl"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="i271bv" className="">
      
      <div id="" className="swiper mySwiper ">
      
      <div id="" className="swiper-wrapper ">
      
      <div id="igbsva" className="swiper-slide ">
      
      <div id="i9tj3e" className="">
      
      <div id="ijjfkf" className="">
      
      <div id="iyglif" className="">
      
      <img
        className=""
        id="ilmmxo"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpr7ru5.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iwvphj" className="">
      
      <img
        className=""
        id="izd7h4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgprf6t0.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i545pr" className="">
      
      <div id="ig2acm" className="">
      
      <div className="" id="iwwho4">
        <>“Pasamos de campañas dispersas a un sistema que vende solo. Reportes claros y crecimiento real.”</>
      </div>
      <>
        </>
      </div>
      
      <div id="ingzyl" className="">
      
      <div className="" id="ifqzry">
        <>María López, Directora de Growth — RetailNow</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="isj7o7" className="swiper-slide ">
      
      <div id="ix5mj5" className="">
      
      <div id="ielavf" className="">
      
      <div id="i8zz5w" className="">
      
      <img
        className=""
        id="i3e21f"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpr7ru5.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iqgs57" className="">
      
      <img
        className=""
        id="iqcl7k"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgprf6t0.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="isgld2" className="">
      
      <div id="ijv4ys" className="">
      
      <div className="" id="ifnlyr">
        <>“Pasamos de campañas dispersas a un sistema que vende solo. Reportes claros y crecimiento real.”</>
      </div>
      <>
        </>
      </div>
      
      <div id="ihp2nw" className="">
      
      <div className="" id="ijqczq">
        <>María López, Directora de Growth — RetailNow</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      </div>
      
      <div id="" className="swiper-button-next ">
      
      </div>
      
      <div id="" className="swiper-button-prev ">
      
      </div>
      
      <div id="" className="swiper-pagination ">
      
      </div>
      
      </div>
      
      <div id="id5cps" className="">
      
      <div id="iy71pe" className="">
      
      <div className="" id="ijc22z">
        
      <span className="" id="inwpef">
        <>Testimonios</>
      </span>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="iz7z68" className="">
      <>
        </>
      </div>
      
      <div id="isqkaw" className="">
      
      <div id="inwpbh" className="">
      
      <div id="iblzwv" className="">
      
      <img
        className=""
        id="i2yoxn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpsbgsp.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="imbbrp" className="">
      
      <div className="" id="i6egud">
        <>¿Listo para crecer con claridad?</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iynesv" className="">
      
      <div id="ibuain" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button2 "
        onClick={async () => {
		function_redirigircontactanos_694618e38e5aed52dc8d5526();
}}

      >
      
      <div id="i4o7pt" className="">
      
      <span className="" id="i1ckiy">
        <>Escríbenos por WhatsApp</>
      </span>
      
      </div>
      
      </button>
      
      <button
        type=""
        name=""
        id="iby52g"
        className=""
        
      >
      
      </button>
      <>
        </>
      </div>
      
      <div id="ilk8u9" className="">
      
      <button
        type=""
        name=""
        id="i86htk"
        className="standard_button "
        onClick={async () => {
		function_redirigircontactanos_694618e38e5aed52dc8d5526();
}}

      >
      
      <div id="ih6ehn" className="">
      <>Agendar una cita</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ia24y4" className="">
      
      <div id="ia2xcx" className="">
      
      <img
        className=""
        id="i6jz6k"
        src="https://assetsprojects.s3.amazonaws.com/405gznimp7daiji.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iox00c" className="">
      
      <div id="iniibd" className="">
      
      <div className="" id="ivn0h8">
        <>Tegucigalpa, Honduras</>
      </div>
      <>
        </>
      </div>
      
      <div id="i8chyb" className="">
      
      <div className="" id="i6qr2i">
        <>+504 123456789</>
      </div>
      <>
        </>
      </div>
      
      <div id="ii4y0z" className="">
      
      <div className="" id="i61inf">
        <>info@origamih.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i3ux4f" className="">
      
        <a
          target=""
          className=""
          id="i31jlr"
          href="/"
        >
          
      <div className="" id="irmqmi">
        <>Inicio</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i7yhko"
          href="/soluciones"
        >
          
      <div className="" id="ilaare">
        <>Soluciones</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i4g5ys"
          href="/sobregrowth"
        >
          
      <div className="" id="ioesvh">
        <>Sobre Origamih</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="iz5mek"
          href="/casosdeexito"
        >
          
      <div className="" id="id56r6">
        <>Casos de Éxito</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="it47lz"
          href="/blog"
        >
          
      <div className="" id="iq4hzi">
        <>Blog</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i3sopc"
          href="/contactanos"
        >
          
      <div className="" id="i37aoh">
        <>Contacto</>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="indubl" className="">
      
      <div id="i21uc2" className="">
      <>
        </>
      </div>
      
      <div id="inwhc2" className="">
      
      <div id="ig0f9m" className="">
      
      <img
        className=""
        id="i8uhy6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpus7um.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ippo57"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjamamuq.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iwkvyf" className="">
      
      <div className="" id="ig7fxf">
        <>© 2025  Origamih. Todos los derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
        <a
          target=""
          className=""
          id="i6ywt2"
          href="https://wa.me/50487475208"
        >
          
      <img
        className=""
        id="i83csk"
        src="https://assetsprojects.s3.amazonaws.com/405gznimll0fka3.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_categorias_app: (value) => dispatch(set_lofty_global_categorias(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pmain);
  